<template>
	<div class="cozeMain" ref="cozeMain">
		<CozeChat agentId="7558105919985958966" :cozeWidth="cozeWidth" title="作业自动诊断助手" />
	</div>
</template>

<script>
	import CozeChat from "@/components/CozeChat.vue";

	export default {
		components: {
			CozeChat
		},
		data() {
			return {
				cozeWidth:0
			}
		},
		mounted() {
			// 通过 this.$refs 获取元素
			const cozeMain = this.$refs.cozeMain;
			if (cozeMain) {
				const width = cozeMain.offsetWidth;
				this.cozeWidth=width
			}
		}
	};
</script>

<style scoped>
.cozeMain{
	max-width: 1300px;
    margin: 0 auto;
}
/* 响应式 */
@media (max-width: 768px) {
	.cozeMain{
		max-width: 90%;
		margin: 0 auto;
	}
}
</style>